import React, { useContext, useState, useEffect } from "react";
import routeConstant from "../../../../route/compoent/routeConstant";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { StoreContext } from "../../../../store/Provider";
import { withStyles } from "@material-ui/core/styles";
import DiscardModal from "./DiscardModal/index";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import "./header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IsLogin } from "../../../../utils";
import { LOCAL_STORAGE_KEY } from "../../../../config";
import jwt_decode from "jwt-decode";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

function Header(props) {
  const context = useContext(StoreContext);
  const navigate = useNavigate();
  const [edit, setEdit] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [viewName, setViewName] = React.useState("");
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [userData, setUserData] = useState({});
  const location = useLocation();

  const logOut = () => {
    handleClose();
    localStorage.clear();
    window.location.reload(false);
  };

  const updatePassword = () => {
    handleClose();
    navigate(routeConstant.UPDATE_PASSWORD);
  };

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("UserDataLogin"));
    // console.log(data,"datatatatatat",context?.omsUserData);
    if (data != null) {
      setViewName(data?.user_fullname);
      // let decoded = jwt_decode(data?.access_token);
      // let objKeys = Object.keys (decoded)
      // let retKey = objKeys.filter((item)=>{
      //   return item.includes("name")
      // })
      // setViewName(decoded[retKey[0]])
    }

    // console.log(decoded[retKey[0]],"dataaaaaa");
  }, [context]);
  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarScroll"
            aria-controls="navbarScroll"
            onClick={props.sidebarHandle}
          >
            <MenuIcon
              className={
                context.closeSidebar
                  ? "pointer toggleSidebar flip"
                  : "pointer toggleSidebar"
              }
            />
          </button>
          <div className="collapse navbar-collapse">
            <MenuIcon
              className={
                context.closeSidebar
                  ? "pointer toggleSidebar flip"
                  : "pointer toggleSidebar"
              }
              onClick={props.sidebarHandle}
            />
            {IsLogin() && (
              <>
                <div className="d-flex ms-auto">
                  <ul className="navbar-nav mb-2 mb-lg-0">
                    <li>
                      <div className="headersearchUser nameid">
                        <span
                          style={{
                            color: "#fff",
                            cursor: "default",
                            display: "none",
                          }}
                        >
                          {location.pathname.includes(
                            routeConstant.ORDER_MAIN
                          ) ? (
                            context.omsUserData?.UserRoles ? (
                              <>({context.omsUserData?.UserRoles})</>
                            ) : (
                              ""
                            )
                          ) : null}
                        </span>
                        {viewName}
                        {/* {context.omsUserData?.FullName?.split(" ")[0]
                          ? context.omsUserData?.FullName?.split(" ")[0]
                          : ""} */}
                        <span>
                          <AccountCircleIcon onClick={handleClick} />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <StyledMenu
                  id="mailMenu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem>{context.omsUserData?.OrgCodes}</MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate(routeConstant.PROFILE);
                      handleClose();
                    }}
                  >
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate(routeConstant.CHANGEPASSWORD);
                      handleClose();
                    }}
                  >
                    Change Password
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      context.setNotificationOpen({
                        open: true,
                        type: "Notification",
                        reload: false,
                      });
                      handleClose();
                    }}
                  >
                    Notification Settings
                  </MenuItem>
                  <MenuItem onClick={logOut}>Log Out</MenuItem>
                </StyledMenu>
              </>
            )}
          </div>
        </div>
      </nav>
      {/* <DiscardModal setEdit={setEdit} /> */}
    </header>
  );
}

export default Header;
